import React, { useState } from 'react'
import styles from './PlayButton.module.scss'
import Icon from '@/component/Primitive/Icon'
import { array, func, object, shape, string } from 'prop-types'
import cx from 'classnames'
import ModalVideo from 'react-modal-video'

export const PlayButton = ({
  className,
  classNames,
  onClick,
  youtubeId,
  options = {}
}) => {
  const { size = [70, 70], disableClick } = options
  const [isOpen, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
    if (onClick) onClick()
  }

  return (
    <>
      {youtubeId && (
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId={youtubeId}
          onClose={() => setOpen(false)}
        />
      )}
      <button
        type="button"
        className={cx(
          styles.PlayButton,
          !disableClick && styles.clickable,
          className
        )}
        onClick={handleClick}
      >
        <Icon
          type="play-circle"
          width={size[0]}
          height={size[1]}
          className={cx(styles.PlayButton, classNames?.icon)}
        />
      </button>
    </>
  )
}

PlayButton.propTypes = {
  className: string,
  classNames: object,
  onClick: func,
  youtubeId: string,
  options: shape({
    size: array
  })
}
